import type { SocialPostEditableDraft } from "@runcheetah/shared";

export function applySocialPostVariantDraft(
  draft: SocialPostEditableDraft,
  generatedAssetId: string,
): SocialPostEditableDraft {
  const variantDraft = (draft.variantDrafts ?? []).find(
    (candidate) => candidate.generatedAssetId === generatedAssetId,
  );

  if (!variantDraft) {
    return draft;
  }

  return {
    ...draft,
    plan: variantDraft.plan,
    imageAssetOverrides: variantDraft.imageAssetOverrides,
    carouselSlides: variantDraft.carouselSlides,
  };
}

export function upsertSocialPostVariantDraft(
  draft: SocialPostEditableDraft,
  generatedAssetId: string,
): SocialPostEditableDraft {
  const variantDraft = {
    generatedAssetId,
    plan: draft.plan,
    imageAssetOverrides: draft.imageAssetOverrides,
    carouselSlides: draft.carouselSlides,
  };

  return {
    ...draft,
    variantDrafts: [
      ...(draft.variantDrafts ?? []).filter(
        (candidate) => candidate.generatedAssetId !== generatedAssetId,
      ),
      variantDraft,
    ],
  };
}
